module.exports = "/_next/static/images/PersonalizeAcrossSitesAppsChannels-9131c3a6178d6f49a3a23fadf6af7a99.webp";